import { xhrPath } from '@/xhr/connections.js';
import picador from '@/xhr/connections/picador';
import state from '../../store/state';

export default {
  async loadMyAccount() {
    return await picador.get('loadMyAccount', xhrPath.userAccount2 + '/me');
  },

  async getNotifications() {
    if (state.userData) {
      return await picador.get('getNotifications', xhrPath.userAccount + '/notifications');
    }
  },
  async getTeamLeadAccess() {
    return await picador.get('getTeamLeadAccess', xhrPath.teamLeadAccess);
  },

  async updateMyUser(userData) {
    return await picador.patch('updateMyUser', xhrPath.userAccount + '/me', userData);
  },

  async loadMyContacts(sort, sortDirection, filterString) {
    const params = { sort, sortDirection };
    if (filterString) {
      params.filterString = filterString;
    }
    return await picador.get('loadMyContacts', xhrPath.userAccount + '/contacts', { params });
  },

  async addMyContacts(contacts) {
    return await picador.post('addMyContacts', xhrPath.contacts({}), contacts);
  },

  async updateContact(contacts) {
    return await picador.put('updateContact', xhrPath.contacts({ contactID: contacts[0]._id }), {
      contacts,
    });
  },

  async updateUserDocument(documentID, archive) {
    return await picador.put('updateUserDocument', xhrPath.userDocuments({ documentID }), {
      archived: archive,
    });
  },
  async updateUserInvitation(invitationID, archive) {
    return await picador.patch('updateUserInvitation', xhrPath.invitation + '/' + invitationID, {
      archived: archive,
    });
  },

  async loadMyTeams(sort, sortDirection, filterString) {
    const params = { sort, sortDirection };
    if (filterString) {
      params.filterString = filterString;
    }
    return await picador.get('loadMyTeams', xhrPath.userAccount + '/teams', {
      params,
    });
  },

  async addMyTeam(team) {
    return await picador.post('addMyTeam', xhrPath.team({}), { team });
  },

  async updateUserDocumentsActive(documentIds, active) {
    return await picador.post(
      'updateUserDocumentsActive',
      xhrPath.userAccount + '/me/document-active',
      { documentIds, active }
    );
  },

  async updateUserDocumentsArchive(documentIds, archived) {
    return await picador.post(
      'updateUserDocumentsArchive',
      xhrPath.userAccount + '/me/document-archive',
      { documentIds, archived }
    );
  },

  async updateUser(userData, userID) {
    return await picador.put('updateUser', xhrPath.userAccount + '/' + userID, userData);
  },

  async patchUser(userData, userID) {
    return await picador.patch('patchUser', xhrPath.userAccount + '/' + userID, userData);
  },

  async getUsersData(userIdsArr, fields) {
    return await picador.get(
      'getUsersData',
      xhrPath.userAccount + '/' + userIdsArr + '?fields=' + fields
    );
  },

  async getUserSummary(userId, page, sort, sortDirection, filterString) {
    const params = { page, sort, sortDirection };
    if (filterString) {
      params.filterString = filterString;
    }
    return await picador.get('getUserSummary', xhrPath.userAccount + '/summary/' + userId, {
      params,
    });
  },
  async getDebateList(userId, page, sort, sortDirection, filterString) {
    const params = { page, sort, sortDirection };
    if (filterString) {
      params.filterString = filterString;
    }
    return await picador.get('getDebateList', xhrPath.userAccount + '/' + userId + '/debate-list', {
      params,
    });
  },
  async getInviteList(documentID, page, sort, sortDirection, filterString) {
    const params = { page, sort, sortDirection };
    if (filterString) {
      params.filterString = filterString;
    }
    return await picador.get('getInviteList', xhrPath.InviteList + `/${documentID}`, { params });
  },
  async getUsers(page, resultsPerPage, sort, sortDirection, filterString) {
    // sortDirection: 'asc' | 'desc'
    const params = { page, resultsPerPage, sort, sortDirection };
    if (filterString && filterString.trim() !== '') {
      params.filterString = filterString;
    }
    return await picador.get('getUsers', xhrPath.userAccount, { params });
  },

  async getUser(id) {
    return await picador.get('getUser', `${xhrPath.userAccount}/${id}`);
  },

  async impersonateUser(id) {
    return await picador.post('impersonateUser', `${xhrPath.userAccount}/${id}/impersonate`);
  },

  async getUserDocuments(page, resultsPerPage, sort, sortDirection, filterString) {
    const params = { page, resultsPerPage, sort, sortDirection, filterString };
    return await picador.get('getUserDocuments', xhrPath.userDebates, { params });
  },

  async getDocumentOwnerNames() {
    return await picador.get(
      'getDocumentOwnerNames',
      `${xhrPath.userAccount}/me/document-owner/names`
    );
  },
};
